export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    },
    {
      option: 'Deck',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/exterior_view02.js